var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "860.000000pt",
    height: "896.000000pt",
    viewBox: "0 0 860.000000 896.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,896.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4030 8535 c-806 -111 -1491 -753 -1710 -1602 -117 -452 -93 -972 66 -1400 223 -605 677 -1074 1244 -1286 356 -133 771 -155 1145 -61 720 182 1314 798 1505 1562 119 475 94 963 -72 1417 -44 121 -149 327 -226 445 -335 512 -854 850 -1422 926 -129 17 -402 16 -530 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2610 4362 c-1033 -482 -1811 -1383 -2142 -2477 -104 -345 -154 -661 -165 -1057 l-6 -218 4003 0 4003 0 -6 218 c-7 236 -17 348 -48 547 -107 676 -392 1317 -828 1863 -294 368 -669 693 -1088 943 -120 71 -407 216 -476 240 l-37 13 -98 -96 c-126 -125 -149 -144 -267 -223 -351 -235 -821 -348 -1311 -316 -544 37 -950 213 -1289 560 -38 39 -76 71 -85 71 -8 0 -80 -31 -160 -68z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicture);
export default __webpack_public_path__ + "static/media/profilePicture.a3d2a95562e356902ed887b98bb49f1f.svg";
export { ForwardRef as ReactComponent };